import styled from 'styled-components';

type StyledBurgerProps = {
  open: boolean;
} & React.HTMLAttributes<HTMLButtonElement>;

export const StyledBurger = styled.button<StyledBurgerProps>`
  position: absolute;
  z-index: 10;
  top: 20px;
  left: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 2rem;
  height: 2rem;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  height: 19px;
  transform: ${({ open }) => (!open ? 'translateX(0)' : 'translateX(200px)')};
  outline: none;
  transition: all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);

  @media (max-width: ${({ theme }) => theme['mobile']}) {
    transform: ${({ open }) => (!open ? 'translateX(0)' : 'translateX(calc(100vw - 60px))')};
  }

  span {
    width: 2rem;
    height: 0.25rem;
    background: ${({ theme, open }) => (!open ? theme['primaryDark'] : theme['primaryLight'])};
    border-radius: 10px;
    transition: all 0.3s linear;
    position: relative;
    transform-origin: 1px;

    :first-child {
      transform: ${({ open }) => (open ? 'rotate(45deg)' : 'rotate(0)')};
    }

    :nth-child(2) {
      opacity: ${({ open }) => (open ? '0' : '1')};
      transform: ${({ open }) => (open ? 'translateX(20px)' : 'translateX(0)')};
    }

    :nth-child(3) {
      transform: ${({ open }) => (open ? 'rotate(-45deg)' : 'rotate(0)')};
    }
  }
`;
